import { Autocomplete, Box, TextField } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export const CustomAutocomplete = (props) => {
  const {
    label,
    value,
    options,
    onChange,
    minWidth = 120,
    maxWidth,
    size = 'small',
    disabled = false,
    loading = false,
    action = () => {},
    type = 'default', // or 'async'
  } = props;

  const dispatch = useDispatch();

  const [inputValue, setInputValue] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    if (type === 'async') {
      const debounceSearch = setTimeout(() => {
        dispatch(action({ page, q: inputValue }));
      }, 500);

      return () => clearTimeout(debounceSearch);
    }
  }, [dispatch, type, action, page, inputValue]);

  const onOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  const onClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onChangeInput = useCallback((event, value) => {
    setInputValue(value);
    setPage(1);
  }, []);

  const onScroll = useCallback(
    (event) => {
      const listboxNode = event.currentTarget;
      const isAtBottom =
        listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 1;

      if (isAtBottom && !loading) {
        setPage((prev) => prev + 1);
      }
    },
    [loading],
  );

  const asyncProps = {
    filterOptions: (x) => x,
  };

  return (
    <Box sx={{ minWidth, maxWidth, width: '100%' }}>
      <Autocomplete
        open={isOpen}
        onOpen={onOpen}
        onClose={onClose}
        disablePortal
        options={options}
        value={value}
        inputValue={inputValue}
        onInputChange={onChangeInput}
        onChange={onChange}
        size={size}
        disabled={disabled}
        loading={loading}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        {...(type === 'async' ? asyncProps : {})}
        ListboxProps={{
          onScroll: onScroll,
          sx: {
            '& li': {
              textAlign: 'left',
            },
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            size={size}
            InputProps={{
              ...params.InputProps,
              endAdornment: params.InputProps.endAdornment,
            }}
          />
        )}
      />
    </Box>
  );
};
